import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { serverurl } from '../../environments/environment';
import { Company, CompanyPublicData } from '../interfaces/company';

@Injectable({
    providedIn: 'root'
})
export class CompanyService {

    constructor(
        private http: HttpClient
    ) { }

    async updateCompanyMetaData(name: string, industryId: string, mission: string, webpage: string): Promise<boolean> {
        return new Promise((resolve) => {
            this.http.post(`${serverurl}/company/metadata`, { name, industryId, mission, webpage }).subscribe({
                next: (data: any) => {
                    resolve(true);
                },
                error: (error) => {
                    resolve(false);
                }
            })
        })
    }
    async getpublicCompanyData(companyId: string): Promise<Company | false> {
        return new Promise((resolve) => {
            this.http.get(`${serverurl}/company/public/${companyId}`).subscribe({
                next: (data: any) => {
                    resolve(data as Company);
                },
                error: (error) => {
                    resolve(false);
                }
            })
        })
    }
}

